import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import { BodyBuilder } from "../../../exports/Images";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import EditImportMemDate from "./EditImportMemDate";
import ImportMemberMobile from "./ImportMemberMobile";
import ImportMemberApprovalForm from "./ImportMemberApprovalForm";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { del_import_member_req } from "../../../data/ApiEndpoints";
import "../../../styles/import-members/import-members.css";
import TableSkeleton from "../../common-components/TableSkeleton";
import { Hourglass } from "react-loader-spinner";
import { CheckCircleIcon, CrossIcon } from "../../../images/icons/icons";
import ReadMoreText from "../../common-components/custom-comps/ReadMoreText";

const AllImportMembers = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
  handleTabSelect,
  selectedTab,
}) => {
  const dispatch = useDispatch();
  const { allSubscriptionDataLoading, allSubscriptionData } = useSelector(
    (state) => state.api
  );
  const {
    importMemberPendingApproval,
    importMemberPendingApprovalLoading,
    importMemberPendingApprovalError,
  } = useSelector((state) => state.payment);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const iniData = {
    pagination: [],
    allImportMembers: [],
  };
  const [allDatas, setAllDatas] = useState(iniData);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    viewImage: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: del_import_member_req,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      selectedTab === 0 &&
      !allSubscriptionDataLoading &&
      allSubscriptionData?.status &&
      allSubscriptionData?.data?.length > 0
    ) {
      const { data, pagination } = allSubscriptionData || [];
      setAllDatas((prevs) => ({
        ...prevs,
        pagination: pagination,
        allImportMembers: data,
      }));
    } else if (
      selectedTab &&
      importMemberPendingApproval?.status &&
      importMemberPendingApproval?.data?.length > 0 &&
      !importMemberPendingApprovalLoading &&
      !importMemberPendingApprovalError
    ) {
      const { data, pagination } = importMemberPendingApproval || [];
      setAllDatas((prevs) => ({
        ...prevs,
        pagination: pagination,
        allImportMembers: data,
      }));
    } else {
      setAllDatas(iniData);
    }
  }, [
    allSubscriptionData,
    allSubscriptionDataLoading,
    importMemberPendingApproval,
    importMemberPendingApprovalLoading,
    importMemberPendingApprovalError,
    selectedTab,
  ]);

  const tbColumns = [
    {
      dataField: "profile",
      text: "profile",
      formatter: (_, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.profile || BodyBuilder}
              alt={row?.user_name || "NA"}
              className="image"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "image",
                  rowData: row,
                  viewImage: row?.profile || BodyBuilder,
                }));
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "member Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "type",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.type || "NA"}</span>;
      },
    },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "price",
      text: "price",
      formatter: (_, row) => {
        return (
          <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "start date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "expire date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "image",
      text: "Invoice",
      formatter: (_, row) => {
        return (
          <div className="actionButtonContainer" style={{ gap: "0" }}>
            <button
              type="button"
              className="actionBtn icon download"
              disabled={!row?.image}
              style={{
                cursor: !row?.image ? "not-allowed" : "pointer",
              }}
            >
              <a href={row?.image}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cloud-arrow-down"
                  viewBox="0 0 16 16"
                  style={{
                    color: !row?.image ? "gray" : "#CD0909",
                    minWidth: "35px",
                    minHeight: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                  />
                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                </svg>
              </a>
            </button>
          </div>
        );
      },
    },
  ];

  const tbColumnsPending = [
    {
      dataField: "image",
      text: "profile",
      formatter: (_, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.image || BodyBuilder}
              alt={row?.user_name || "NA"}
              className="image"
              onClick={() => {
                row?.image &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "image",
                    rowData: row,
                    viewImage: row?.image || BodyBuilder,
                  }));
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "type",
      text: "plan",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-col minWidth150">
            <small>{row?.type || "NA"}</small>
            <b>{row?.plan_name || "NA"}</b>
            <small>
              (₹{convertThenFormat(row?.price || 0)}/{row?.plan_duration || "-"}
              Days )
            </small>
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "start/expire date",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            <small>
              {row?.start_date ? convertStraight(row.start_date) : "-"}
              <br />
              {row?.end_date ? convertStraight(row.end_date) : "-"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "plan Status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: row?.status === "active" ? "#0A701B" : "#F13434",
              color: "#fff",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.status || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "image",
      text: "Invoice",
      formatter: (_, row) => {
        return (
          <div className="actionButtonContainer" style={{ gap: "0" }}>
            <button
              type="button"
              className="actionBtn icon download"
              disabled={!row?.image}
              style={{
                cursor: !row?.image ? "not-allowed" : "pointer",
              }}
            >
              <a href={row?.image}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cloud-arrow-down"
                  viewBox="0 0 16 16"
                  style={{
                    color: !row?.image ? "gray" : "#CD0909",
                    minWidth: "35px",
                    minHeight: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                  />
                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                </svg>
              </a>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "approval status",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.approval_status === 1 ? (
              <CheckCircleIcon color="#209216" />
            ) : row?.approval_status === 2 ? (
              <CrossIcon color="#E41815" />
            ) : (
              <Hourglass color="#EB5B00" />
            )}
          </span>
        );
      },
    },
    selectedTab !== 1 && {
      dataField: "aprv_rej_description",
      text: "remarks",
      formatter: (_, row) => (
        <ReadMoreText
          text={row?.aprv_rej_description || "NA"}
          maxLength={30}
          className="tb-data minWidth150"
        />
      ),
    },
    {
      dataField: "requested_by",
      text: "requested by",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.requested_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.requested_by_mobile || ""}
              <br />
              {row?.requested_by_email || ""}
            </small>
          </span>
        );
      },
    },
    selectedTab !== 1 && {
      dataField: "aprv_rej_by",
      text: "approve/rejected by",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.aprv_rej_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.aprv_rej_by_mobile || ""}
              <br />
              {row?.aprv_rej_by_email || ""}
            </small>
          </span>
        );
      },
    },
    selectedTab === 1 && {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => {
        const isEditable =
          row?.status === "active" && row?.approval_status === 0;
        const filters = {
          uid: row?.uid || "",
        };

        return (
          <div className="actionButtonContainer tb-col">
            <div className="flexStart" style={{ columnGap: "5px" }}>
              <button
                className="actionBtn icon edit"
                disabled={!isEditable}
                style={{
                  cursor: !isEditable ? "not-allowed" : "pointer",
                  opacity: !isEditable ? "0.5" : "1",
                }}
                onClick={() =>
                  isEditable &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "edit",
                    rowData: row,
                  }))
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#CD0909",
                  }}
                >
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </button>
              <button
                className="actionBtn icon edit"
                disabled={row?.approval_status !== 0}
                style={{
                  cursor:
                    row?.approval_status === 0 ? "pointer" : "not-allowed",
                  opacity: row?.approval_status === 0 ? "1" : "0.5",
                }}
                onClick={() =>
                  row?.approval_status === 0 && handleDelete(filters)
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash3-fill"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#CD0909",
                  }}
                >
                  <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                </svg>
              </button>
            </div>

            {(isAdmin || isClusterManager) && row?.approval_status === 0 && (
              <div className="flexStart" style={{ columnGap: "5px" }}>
                <Button
                  type="button"
                  variant="primary"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "approve",
                      rowData: row,
                    }))
                  }
                >
                  Approve
                </Button>
                <Button
                  type="button"
                  variant="danger"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "reject",
                      rowData: row,
                    }))
                  }
                >
                  Reject
                </Button>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="View Image Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          {modValues.cardName !== "approve" &&
            modValues.cardName !== "reject" && (
              <ModalHeadAndClose title=" " onClose={onCloseModal} />
            )}

          {modValues.cardName === "image" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : modValues.cardName === "edit" ? (
            <EditImportMemDate
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              callFunction={callFunction}
              onCloseModal={onCloseModal}
            />
          ) : modValues.cardName === "approve" ||
            modValues.cardName === "reject" ? (
            <ImportMemberApprovalForm
              userInfoData={userInfoData}
              cardName={modValues.cardName}
              rowData={modValues.rowData}
              callFunction={callFunction}
              closeModal={onCloseModal}
            />
          ) : null}
        </div>
      </Modal>

      <div className="blog-form-tabs-container tab-auto-wrap mt30">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
          <TabList>
            <Tab>Import Members</Tab>
            <Tab>Pending Approval</Tab>
            <Tab>Approved</Tab>
            <Tab>Rejected</Tab>
          </TabList>

          <TabPanel>
            {allSubscriptionDataLoading ? (
              <TableSkeleton columns={9} rows={5} />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
                  <PaymentLinkTable
                    tableData={allDatas.allImportMembers}
                    tableColumns={tbColumns}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <ImportMemberMobile
                    tableData={allDatas.allImportMembers}
                    tablePagination={allDatas?.pagination}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    isAdmin={isAdmin}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {importMemberPendingApprovalLoading ? (
              <TableSkeleton columns={9} rows={5} />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
                  <PaymentLinkTable
                    tableData={allDatas.allImportMembers}
                    tableColumns={tbColumnsPending}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <ImportMemberMobile
                    tableData={allDatas.allImportMembers}
                    tablePagination={allDatas?.pagination}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    isAdmin={isAdmin}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {importMemberPendingApprovalLoading ? (
              <TableSkeleton columns={9} rows={5} />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
                  <PaymentLinkTable
                    tableData={allDatas.allImportMembers}
                    tableColumns={tbColumnsPending}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <ImportMemberMobile
                    tableData={allDatas.allImportMembers}
                    tablePagination={allDatas?.pagination}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    isAdmin={isAdmin}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {importMemberPendingApprovalLoading ? (
              <TableSkeleton columns={9} rows={5} />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
                  <PaymentLinkTable
                    tableData={allDatas.allImportMembers}
                    tableColumns={tbColumnsPending}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <ImportMemberMobile
                    tableData={allDatas.allImportMembers}
                    tablePagination={allDatas?.pagination}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    isAdmin={isAdmin}
                  />
                </div>
              </>
            )}
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default AllImportMembers;
